import confetti from 'canvas-confetti';

let fired = false;

function fire() {
    if (!fired) {
        fired = true;
        confetti({
            particleCount: 20,
            spread: 100,
            origin: { y: 0.6 },
            shapes: ['star'],
            colors: ['#FCBF02'],
            scalar: 1.0,
        });
        setTimeout(() => {
            fired = false;
        }, 2000);
    }
}

export default {
    fire,
};